import { gql } from '@apollo/client';

export const ADMIN_BRAND_LEAD_SUBMISSIONS = gql`
  query AdminBrandLeadSubmissions($page: Int, $pageSize: Int, $search: String, $origin: String) {
    adminBrandLeadSubmissions(page: $page, pageSize: $pageSize, search: $search, origin: $origin) {
      data {
        documentId
        isDuplicate
        submittedAt
        lead {
          documentId
          name
          email
          phone
          website
          social
          company
          demandType
          objective
          contentType
          platforms
          budget
          source
          utm
          createdAt
          updatedAt
        }
      }
      total
      page
      pageSize
      pageCount
      originCounts {
        app
        site
        marcas
        other
      }
    }
  }
`;
